import React from 'react';
import Dentaku from './component/Dentaku';

function App() {
  return (
    <div className="App">
      <Dentaku />
    </div>
  );
}

export default App;
